module.exports = {
      id: "arrow-short-bottom-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.209f7259.svg#arrow-short-bottom-usage",
      toString: function () {
        return this.url;
      }
    }